import type { FilterSelectionsMap } from '../../../filters/types/filters';
import type { DataProviderSet } from '../../DataProvider/types';
import type { ReportParameterConfig } from '../../PageConfigProvider/page-reducer';
import type { PlotParameter } from '../../PageConfigProvider/types/item';
import { aggregateParameterData } from './aggregate-parameter-data';
import { getPrimaryParameterSelections } from './get-primary-parameter-selections';

export const getParameterAggregatedData = ({
  data,
  plotParameters,
  reportParameters,
  activeFilterMap,
}: {
  data: DataProviderSet;
  plotParameters: PlotParameter[];
  reportParameters: ReportParameterConfig[];
  activeFilterMap: FilterSelectionsMap;
}) => {
  const groupedParameter = plotParameters.find((p) => p.grouped);

  if (!groupedParameter) return data;

  const parameter = reportParameters.find(
    (p) => p.parameterId === groupedParameter.parameterId
  );
  if (!parameter) return data;

  const filter = activeFilterMap.get(parameter.filterId);
  if (!filter) return data;

  const primaryFilterDimensions = getPrimaryParameterSelections({
    reportParameters,
    activeFilterMap,
  });

  const aggregatedData = aggregateParameterData({
    data,
    parameterName: parameter.name,
    aggregationType: 'AVG',
    primaryFilterDimensions,
  });

  return aggregatedData;
};
